const ProfileIconDark = (): JSX.Element => {
	return (
		<svg
			fill="none"
			height="21"
			viewBox="0 0 15 21"
			width="15"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.5 1.5C8.24168 1.5 8.9667 1.71993 9.58339 2.13199C10.2001 2.54404 10.6807 3.12971 10.9645 3.81494C11.2484 4.50016 11.3226 5.25416 11.1779 5.98159C11.0333 6.70902 10.6761 7.3772 10.1517 7.90165C9.6272 8.4261 8.95902 8.78325 8.23159 8.92795C7.50416 9.07264 6.75016 8.99838 6.06494 8.71455C5.37971 8.43072 4.79404 7.95007 4.38199 7.33339C3.96993 6.7167 3.75 5.99168 3.75 5.25C3.75 4.25544 4.14509 3.30161 4.84835 2.59835C5.55161 1.89509 6.50544 1.5 7.5 1.5ZM7.5 0C6.46165 0 5.44661 0.307907 4.58326 0.884785C3.7199 1.46166 3.04699 2.2816 2.64963 3.24091C2.25227 4.20022 2.1483 5.25582 2.35088 6.27422C2.55345 7.29262 3.05346 8.22809 3.78769 8.96231C4.52191 9.69654 5.45738 10.1965 6.47578 10.3991C7.49418 10.6017 8.54978 10.4977 9.50909 10.1004C10.4684 9.70301 11.2883 9.0301 11.8652 8.16674C12.4421 7.30339 12.75 6.28835 12.75 5.25C12.75 3.85761 12.1969 2.52226 11.2123 1.53769C10.2277 0.553123 8.89239 0 7.5 0Z"
				fill="#212B36"
			/>
			<path
				d="M15 21H13.5V17.25C13.5 16.7575 13.403 16.2699 13.2145 15.8149C13.0261 15.36 12.7499 14.9466 12.4017 14.5983C12.0534 14.2501 11.64 13.9739 11.1851 13.7855C10.7301 13.597 10.2425 13.5 9.75 13.5H5.25C4.25544 13.5 3.30161 13.8951 2.59835 14.5983C1.89509 15.3016 1.5 16.2554 1.5 17.25V21H0V17.25C0 15.8576 0.553124 14.5223 1.53769 13.5377C2.52226 12.5531 3.85761 12 5.25 12H9.75C11.1424 12 12.4777 12.5531 13.4623 13.5377C14.4469 14.5223 15 15.8576 15 17.25V21Z"
				fill="#212B36"
			/>
			<path
				d="M0.5 17C0.5 14.7909 2.29086 13 4.5 13H10.5C12.7091 13 14.5 14.7909 14.5 17V21H0.5V17Z"
				fill="#212B36"
			/>
			<path
				d="M11.5 5.5C11.5 7.70914 9.70914 9.5 7.5 9.5C5.29086 9.5 3.5 7.70914 3.5 5.5C3.5 3.29086 5.29086 1.5 7.5 1.5C9.70914 1.5 11.5 3.29086 11.5 5.5Z"
				fill="#212B36"
			/>
		</svg>
	);
};

export default ProfileIconDark;
